import Axios from 'axios';
import {
    ALL_COLLECTIONS_FETCH_ERROR,
    ALL_COLLECTIONS_FETCH_IN_PROGRESS,
    ALL_COLLECTIONS_FETCH_SUCCESS,
    BURN_NFT_CONFIRM_DIALOG_HIDE,
    BURN_NFT_CONFIRM_DIALOG_SHOW,
    CANCEL_FETCH_ALL_COLLECTIONS,
    CANCEL_FETCH_COLLECTIONS,
    CANCEL_FETCH_NON_CONTRACT_COLLECTIONS,
    COLLECTION_CONFIRM_DIALOG_HIDE,
    COLLECTION_CONFIRM_DIALOG_SHOW,
    COLLECTION_FETCH_ERROR,
    COLLECTION_FETCH_IN_PROGRESS,
    COLLECTION_FETCH_SUCCESS,
    COLLECTIONS_FETCH_ERROR,
    COLLECTIONS_FETCH_IN_PROGRESS,
    COLLECTIONS_FETCH_SUCCESS,
    FETCH_NON_CONTRACT_COLLECTIONS_ERROR,
    FETCH_NON_CONTRACT_COLLECTIONS_IN_PROGRESS,
    FETCH_NON_CONTRACT_COLLECTIONS_SUCCESS,
    FETCH_LISTED_COLLECTION_NFT_S_ERROR,
    FETCH_LISTED_COLLECTION_NFT_S_IN_PROGRESS,
    FETCH_LISTED_COLLECTION_NFT_S_SUCCESS,
    FETCH_NON_LISTED_COLLECTION_NFT_S_ERROR,
    FETCH_NON_LISTED_COLLECTION_NFT_S_IN_PROGRESS,
    FETCH_NON_LISTED_COLLECTION_NFT_S_SUCCESS,
    FETCH_NON_TRANSFERABLE_COLLECTION_NFT_S_ERROR,
    FETCH_NON_TRANSFERABLE_COLLECTION_NFT_S_IN_PROGRESS,
    FETCH_NON_TRANSFERABLE_COLLECTION_NFT_S_SUCCESS,
    MINT_NFT_ADD_ERROR,
    MINT_NFT_ADD_IN_PROGRESS,
    MINT_NFT_ADD_SUCCESS,
    MINT_NFT_CONFIRM_DIALOG_HIDE,
    MINT_NFT_CONFIRM_DIALOG_SHOW,
    MINT_NFT_ERROR,
    MINT_NFT_IN_PROGRESS,
    MINT_NFT_SUCCESS,
    NEW_COLLECTION_DATA_SET,
    NFT_FETCH_ERROR,
    NFT_FETCH_IN_PROGRESS,
    NFT_FETCH_SUCCESS,
    NFT_LIST_FETCH_ERROR,
    NFT_LIST_FETCH_IN_PROGRESS,
    NFT_LIST_FETCH_SUCCESS,
    NFT_LIST_OWNED_FETCH_ERROR,
    NFT_LIST_OWNED_FETCH_IN_PROGRESS,
    NFT_LIST_OWNED_FETCH_SUCCESS,
    TRANSFER_NFT_CONFIRM_DIALOG_HIDE,
    TRANSFER_NFT_CONFIRM_DIALOG_SHOW,
    NFT_LIST_ALL_FETCH_IN_PROGRESS,
    NFT_LIST_ALL_FETCH_ERROR,
    NFT_LIST_ALL_FETCH_SUCCESS,
} from '../../constants/createAssets/mintNft';
import {
    MINT_NFT_URL,
    urlFetchAllCollections,
    urlFetchCollectionInfo,
    urlFetchCollections,
    urlFetchNFT,
    urlFetchNFTList,
    urlFetchNFTListOwned,
    urlFetchNonContractCollections,
    urlListedCollectionNfts,
    urlNonListedCollectionNfts,
    urlNonTransferableCollectionNfts,
    urlFetchNFTListAll,
} from '../../constants/restURL';
import { urlMintNft } from '../../constants/url';
import { handleErrorMessage } from '../../utils/errorMessages';

export const showTransferNFTConfirmDialog = (value) => {
    return {
        type: TRANSFER_NFT_CONFIRM_DIALOG_SHOW,
        value,
    };
};

export const hideTransferNFTConfirmDialog = () => {
    return {
        type: TRANSFER_NFT_CONFIRM_DIALOG_HIDE,
    };
};

export const showBurnNFTConfirmDialog = (value) => {
    return {
        type: BURN_NFT_CONFIRM_DIALOG_SHOW,
        value,
    };
};

export const hideBurnNFTConfirmDialog = () => {
    return {
        type: BURN_NFT_CONFIRM_DIALOG_HIDE,
    };
};

export const showCollectionConfirmDialog = (value) => {
    return {
        type: COLLECTION_CONFIRM_DIALOG_SHOW,
        value,
    };
};

export const hideCollectionConfirmDialog = () => {
    return {
        type: COLLECTION_CONFIRM_DIALOG_HIDE,
    };
};

export const showMintNFTConfirmDialog = (value) => {
    return {
        type: MINT_NFT_CONFIRM_DIALOG_SHOW,
        value,
    };
};

export const hideMintNFTConfirmDialog = () => {
    return {
        type: MINT_NFT_CONFIRM_DIALOG_HIDE,
    };
};

const fetchCollectionsInProgress = () => {
    return {
        type: COLLECTIONS_FETCH_IN_PROGRESS,
    };
};

const fetchCollectionsSuccess = (value, skip, limit, search, total) => {
    return {
        type: COLLECTIONS_FETCH_SUCCESS,
        value,
        skip,
        limit,
        search,
        total,
    };
};

const fetchCollectionsError = (message) => {
    return {
        type: COLLECTIONS_FETCH_ERROR,
        message,
    };
};

const cancelFetchCollections = (cancel) => {
    return {
        type: CANCEL_FETCH_COLLECTIONS,
        cancel,
    };
};

export const fetchCollections = (address, skip, limit, search, cb) => (dispatch) => {
    dispatch(fetchCollectionsInProgress());

    const url = urlFetchCollections(address, skip, limit, search);
    const CancelToken = Axios.CancelToken;
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
        cancelToken: new CancelToken((cancel) => {
            dispatch(cancelFetchCollections(cancel));
        }),
    })
        .then((res) => {
            dispatch(fetchCollectionsSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, search, res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchCollectionsError(message));

            if (cb) {
                cb(null);
            }
        });
};

const fetchNonContractCollectionsInProgress = () => {
    return {
        type: FETCH_NON_CONTRACT_COLLECTIONS_IN_PROGRESS,
    };
};

const fetchNonContractCollectionsSuccess = (value, skip, limit, search, total) => {
    return {
        type: FETCH_NON_CONTRACT_COLLECTIONS_SUCCESS,
        value,
        skip,
        limit,
        search,
        total,
    };
};

const fetchNonContractCollectionsError = (message) => {
    return {
        type: FETCH_NON_CONTRACT_COLLECTIONS_ERROR,
        message,
    };
};

const cancelFetchNonContractCollections = (cancel) => {
    return {
        type: CANCEL_FETCH_NON_CONTRACT_COLLECTIONS,
        cancel,
    };
};

export const fetchNonContractCollections = (address, skip, limit, search, cb) => (dispatch) => {
    dispatch(fetchNonContractCollectionsInProgress());

    const url = urlFetchNonContractCollections(address, skip, limit, search);
    const CancelToken = Axios.CancelToken;
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
        cancelToken: new CancelToken((cancel) => {
            dispatch(cancelFetchNonContractCollections(cancel));
        }),
    })
        .then((res) => {
            dispatch(fetchNonContractCollectionsSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, search, res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchNonContractCollectionsError(message));

            if (cb) {
                cb(null);
            }
        });
};

const fetchAllCollectionsInProgress = () => {
    return {
        type: ALL_COLLECTIONS_FETCH_IN_PROGRESS,
    };
};

const fetchAllCollectionsSuccess = (value, skip, limit, search, total) => {
    return {
        type: ALL_COLLECTIONS_FETCH_SUCCESS,
        value,
        skip,
        limit,
        search,
        total,
    };
};

const fetchAllCollectionsError = (message) => {
    return {
        type: ALL_COLLECTIONS_FETCH_ERROR,
        message,
    };
};

const cancelFetchAllCollections = (cancel) => {
    return {
        type: CANCEL_FETCH_ALL_COLLECTIONS,
        cancel,
    };
};

export const fetchAllCollections = (skip, limit, search, cb) => (dispatch) => {
    dispatch(fetchAllCollectionsInProgress());

    const url = urlFetchAllCollections(skip, limit, search);
    const CancelToken = Axios.CancelToken;
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
        cancelToken: new CancelToken((cancel) => {
            dispatch(cancelFetchAllCollections(cancel));
        }),
    })
        .then((res) => {
            dispatch(fetchAllCollectionsSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, search, res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchAllCollectionsError(message));

            if (cb) {
                cb(null);
            }
        });
};

const fetchCollectionInProgress = () => {
    return {
        type: COLLECTION_FETCH_IN_PROGRESS,
    };
};

const fetchCollectionSuccess = (value) => {
    return {
        type: COLLECTION_FETCH_SUCCESS,
        value,
    };
};

const fetchCollectionError = (message) => {
    return {
        type: COLLECTION_FETCH_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchCollection = (id, cb) => (dispatch) => {
    dispatch(fetchCollectionInProgress());

    const url = urlFetchCollectionInfo(id);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            if (res.data && res.data.result) {
                dispatch(fetchCollectionSuccess(res.data.result));
                if (cb) {
                    cb(res.data.result);
                }
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchCollectionError(message));

            if (cb) {
                cb(null);
            }
        });
};

export const setNewCollectionData = (value) => {
    return {
        type: NEW_COLLECTION_DATA_SET,
        value,
    };
};

const addMintNftInProgress = () => {
    return {
        type: MINT_NFT_ADD_IN_PROGRESS,
    };
};

const addMintNftSuccess = (value) => {
    return {
        type: MINT_NFT_ADD_SUCCESS,
        value,
    };
};

const addMintNftError = (message) => {
    return {
        type: MINT_NFT_ADD_ERROR,
        message,
        variant: 'error',
    };
};

export const addMintNft = (data, cb) => (dispatch) => {
    dispatch(addMintNftInProgress());

    Axios.post(MINT_NFT_URL, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(addMintNftSuccess(res.data));
            cb(res.data);
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(addMintNftError(message));

            cb(null);
        });
};

const mintNftInProgress = () => {
    return {
        type: MINT_NFT_IN_PROGRESS,
    };
};

const mintNftSuccess = (value) => {
    return {
        type: MINT_NFT_SUCCESS,
        value,
    };
};

const mintNftError = (message) => {
    return {
        type: MINT_NFT_ERROR,
        message,
        variant: 'error',
    };
};

export const mintNft = (data, id, route, cb) => (dispatch) => {
    dispatch(mintNftInProgress());

    const url = urlMintNft(id) + route;
    Axios.put(url, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(mintNftSuccess(res.data && res.data.result));
            cb(null);
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(mintNftError(message));

            cb(error);
        });
};

const fetchNftListInProgress = () => {
    return {
        type: NFT_LIST_FETCH_IN_PROGRESS,
    };
};

const fetchNftListSuccess = (value) => {
    return {
        type: NFT_LIST_FETCH_SUCCESS,
        value,
    };
};

const fetchNftListError = (message) => {
    return {
        type: NFT_LIST_FETCH_ERROR,
        message,
    };
};

export const fetchNftList = (id) => (dispatch) => {
    dispatch(fetchNftListInProgress());

    const url = urlFetchNFTList(id);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(fetchNftListSuccess(res.data && res.data.result && res.data.result.collection));
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchNftListError(message));
        });
};

const fetchNftListOwnedInProgress = () => {
    return {
        type: NFT_LIST_OWNED_FETCH_IN_PROGRESS,
    };
};

const fetchNftListOwnedSuccess = (value, skip, limit, search, total) => {
    return {
        type: NFT_LIST_OWNED_FETCH_SUCCESS,
        value,
        skip,
        limit,
        search,
        total,
    };
};

const fetchNftListOwnedError = (message) => {
    return {
        type: NFT_LIST_OWNED_FETCH_ERROR,
        message,
    };
};

export const fetchNftListOwned = (address, skip, limit, search, listed, cb) => (dispatch) => {
    dispatch(fetchNftListOwnedInProgress());

    const url = urlFetchNFTListOwned(address, skip, limit, search, listed);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(fetchNftListOwnedSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, search, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchNftListOwnedError(message));

            if (cb) {
                cb(null);
            }
        });
};

const fetchNftListAllInProgress = () => {
    return {
        type: NFT_LIST_ALL_FETCH_IN_PROGRESS,
    };
};

const fetchNftListAllSuccess = (value, skip, limit, search, total) => {
    return {
        type: NFT_LIST_ALL_FETCH_SUCCESS,
        value,
        skip,
        limit,
        search,
        total,
    };
};

const fetchNftListAllError = (message) => {
    return {
        type: NFT_LIST_ALL_FETCH_ERROR,
        message,
    };
};

export const fetchNftListAll = (address, skip, limit, search, listed, cb) => (dispatch) => {
    dispatch(fetchNftListAllInProgress());

    const url = urlFetchNFTListAll(address, skip, limit, search, listed);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(fetchNftListAllSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, search, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchNftListAllError(message));

            if (cb) {
                cb(null);
            }
        });
};

const fetchNftInProgress = () => {
    return {
        type: NFT_FETCH_IN_PROGRESS,
    };
};

const fetchNftSuccess = (value) => {
    return {
        type: NFT_FETCH_SUCCESS,
        value,
    };
};

const fetchNftError = (message) => {
    return {
        type: NFT_FETCH_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchNft = (denomID, onftId) => (dispatch) => {
    dispatch(fetchNftInProgress());

    const url = urlFetchNFT(denomID, onftId);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(fetchNftSuccess(res.data && res.data.result));
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchNftError(message));
        });
};

const fetchListedCollectionNFTsInProgress = () => {
    return {
        type: FETCH_LISTED_COLLECTION_NFT_S_IN_PROGRESS,
    };
};

const fetchListedCollectionNFTsSuccess = (value, skip, limit, total) => {
    return {
        type: FETCH_LISTED_COLLECTION_NFT_S_SUCCESS,
        value,
        skip,
        limit,
        total,
    };
};

const fetchListedCollectionNFTsError = (message) => {
    return {
        type: FETCH_LISTED_COLLECTION_NFT_S_ERROR,
        message,
    };
};

export const fetchListedCollectionNFTs = (id, address, skip, limit, search, priceDenom, minPrice, maxPrice, cb) => (dispatch) => {
    dispatch(fetchListedCollectionNFTsInProgress());

    const url = urlListedCollectionNfts(id, address, skip, limit, search, priceDenom, minPrice, maxPrice);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(fetchListedCollectionNFTsSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchListedCollectionNFTsError(message));

            if (cb) {
                cb(null);
            }
        });
};

const fetchNonListedCollectionNFTsInProgress = () => {
    return {
        type: FETCH_NON_LISTED_COLLECTION_NFT_S_IN_PROGRESS,
    };
};

const fetchNonListedCollectionNFTsSuccess = (value, skip, limit, total) => {
    return {
        type: FETCH_NON_LISTED_COLLECTION_NFT_S_SUCCESS,
        value,
        skip,
        limit,
        total,
    };
};

const fetchNonListedCollectionNFTsError = (message) => {
    return {
        type: FETCH_NON_LISTED_COLLECTION_NFT_S_ERROR,
        message,
    };
};

export const fetchNonListedCollectionNFTs = (id, address, skip, limit, search, cb) => (dispatch) => {
    dispatch(fetchNonListedCollectionNFTsInProgress());

    const url = urlNonListedCollectionNfts(id, address, skip, limit, search);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(fetchNonListedCollectionNFTsSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchNonListedCollectionNFTsError(message));

            if (cb) {
                cb(null);
            }
        });
};

const fetchNonTransferableCollectionNFTsInProgress = () => {
    return {
        type: FETCH_NON_TRANSFERABLE_COLLECTION_NFT_S_IN_PROGRESS,
    };
};

const fetchNonTransferableCollectionNFTsSuccess = (value, skip, limit, total) => {
    return {
        type: FETCH_NON_TRANSFERABLE_COLLECTION_NFT_S_SUCCESS,
        value,
        skip,
        limit,
        total,
    };
};

const fetchNonTransferableCollectionNFTsError = (message) => {
    return {
        type: FETCH_NON_TRANSFERABLE_COLLECTION_NFT_S_ERROR,
        message,
    };
};

export const fetchNonTransferableCollectionNFTs = (id, address, skip, limit, search, cb) => (dispatch) => {
    dispatch(fetchNonTransferableCollectionNFTsInProgress());

    const url = urlNonTransferableCollectionNfts(id, address, skip, limit, search);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(fetchNonTransferableCollectionNFTsSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchNonTransferableCollectionNFTsError(message));

            if (cb) {
                cb(null);
            }
        });
};
